import dayjs from 'dayjs';
import { formatActivityInfo } from './common';

export const todayHasEvents = ({ date, eventDates }) => {
  const todayEvents = eventDates.filter((d) =>
    dayjs(new Date(date)).isSame(dayjs(new Date(d * 1000)), 'day')
  );

  return todayEvents;
};

const noDetailsMsg = 'I dettagli saranno disponibili dopo la registrazione';
export const renderAddress = ({
  type,
  platform_name,
  city,
  region,
  district,
  country,
  postal_code,
  street_name,
  street_number,
}) => {
  if (type === 'online' || type === 'online_bbb') {
    return platform_name || noDetailsMsg;
  }
  if (
    !city?.trim() &&
    !region?.trim() &&
    !district?.trim() &&
    !country?.trim() &&
    !postal_code?.trim() &&
    !street_name?.trim() &&
    !street_number?.trim()
  ) {
    return noDetailsMsg;
  }
  // first line
  let address = '<div>';
  if (city) address += `${city} `;
  if (district) address += `(${district}), `;
  if (region) address += `${region}, `;
  if (country) address += `${country}`;
  address += '</div>';
  // second line
  address += '<div>';
  if (postal_code) address += `${postal_code} `;
  if (street_name) address += `${street_name}, `;
  if (street_number) address += `${street_number} `;
  address += '</div>';
  return address;
};

export const sessionIsLive = (activity = {}) => {
  const { tsStart: start_time, tsEnd: end_time } = formatActivityInfo(activity);
  const now = dayjs().unix();
  const deltamin = 5 * 60; // 5 min
  return start_time - deltamin < now && now < end_time;
};

export const registrationIsAllowed = ({
  max_number,
  registered_number,
  registration_start_date,
  registration_end_date,
}) => {
  const today = dayjs().unix();
  if (max_number > 0 && registered_number >= max_number) return false;
  if (registration_start_date > today || today > registration_end_date) {
    return false;
  }

  return true;
};

export const getFilterDates = (months = 1) => {
  const today = dayjs();
  const start_date = today.format('DD-MM-YYYY');
  const end_date = today.add(months, 'month').format('DD-MM-YYYY');
  return {
    start_date,
    end_date,
  };
};

export const getEventDates = (day = dayjs().unix(), prevNextMonths = 1) => {
  const prevMonth = dayjs(day * 1000).subtract(prevNextMonths, 'month');
  const nextMonth = dayjs(day * 1000).add(prevNextMonths, 'month');
  const start_date = prevMonth.startOf('month').format('DD-MM-YYYY');
  const end_date = nextMonth.endOf('month').format('DD-MM-YYYY');
  return {
    start_date,
    end_date,
  };
};
